// export this package's api
import Drawer from './Drawer';

export default Drawer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-drawer@1.7.3@rc-drawer/es/index.js
// module id = 567
// module chunks = 0 1